/**
 *
 * Asynchronously loads the component for Preferences
 *
 */

import loadable from '@loadable/component';

export default loadable(() => import('./index'));
